import { vxFormatCount } from '@voxie/frontend-components';
import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { analyticsClient } from '../../../../services';

export const useMarketingSubscriptionsTotalByStatus = createGlobalState(() => {
    const error = ref(false);
    const loading = ref(false);
    const data = ref([]);

    const titleFor = (status) => {
        switch (status) {
            case 'opt_in':
                return 'Total Subscribers';
            case 'opt_out':
                return 'Total Unsubscribers';
            case 'unknown':
                return 'Potential Subscribers';
            default:
                return 'Total Contacts';
        }
    };

    const dataFor = (status) => {
        const number = data.value
            .filter((group) => (status ? group.group_id === status : group.group_id !== undefined))
            .reduce((acc, curr) => acc + (curr.value || 0), 0);

        return {
            number: number,
            label: vxFormatCount(number),
            title: titleFor(status),
        };
    };

    const fetchData = () => {
        if (loading.value) {
            return;
        }

        loading.value = true;
        analyticsClient
            .marketingSubscriptionsTotalByStatus(Spark.state.currentTeam.id)
            .then((res) => {
                data.value = res.data.data;
            })
            .catch((e) => {
                console.error(e);
                data.value = [];
                error.value = true;
            })
            .finally(() => {
                loading.value = false;
            });
    };

    return {
        loading,
        dataFor,
        fetchData,
        error,
    };
});
